import { useEffect } from "react";
import { toast } from "sonner";
import { useDeployedVersionPolling } from "@/hooks/use-app-version";
import { useClientOutdated } from "@/hooks/use-client-outdated";

const TOAST_ID = "app-update-available";

/**
 * Single refresh prompt for a stale client bundle, fed by both triggers: the
 * proactive deployed-version poll and the reactive apiClient `CLIENT_OUTDATED`
 * interceptor. Non-blocking: the sticky toast offers a Refresh action but never
 * forces the reload, so it won't interrupt in-progress work. The one flow that
 * cannot tolerate a stale bundle — checkout — forces the reload separately.
 */
export function AppVersionWatcher() {
	useDeployedVersionPolling();
	const outdated = useClientOutdated();

	useEffect(() => {
		if (!outdated) return;
		toast("Your version of Coffitivity is out of date. Click here to update.", {
			id: TOAST_ID,
			duration: Number.POSITIVE_INFINITY,
			action: {
				label: "Refresh",
				onClick: () => window.location.reload(),
			},
		});
	}, [outdated]);

	return null;
}
